import { customAlphabet } from 'nanoid'

// Alnum only: nanoid's default alphabet includes `-`/`_`, which `.toUpperCase()` wouldn't
// remove and would break the `RLY-XXXX-XX` format below.
const referenceId = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', 6)

// RAL-163: the quotable reference every error page shows (`RLY-4E82-9C` per the approved
// design). Generated client-side for a render/loader crash the frontend catches on its own —
// there's no frontend Sentry wiring yet (backend-only, backend/instrument.ts), so this can't
// be tied to a real captured-event id today; that gap is tracked as follow-up. When a failure
// originates server-side with its own logged ref (mirroring backend/routes/oauth.ts's
// `supportRef()`), callers should pass that value through instead of generating a new one.
export function generateReference(): string {
  const id = referenceId()
  return `RLY-${id.slice(0, 4)}-${id.slice(4, 6)}`
}
